import { Injectable } from '@angular/core'
import { Apollo, gql } from 'apollo-angular'
import { reportHandled } from './core/errors/issueTracker'
import { featuresSetting } from './types/featuresSetting'

export interface FeatureList {
  dicomViewer?: boolean
  /** the Scanners list shows each scanner's serial number (from its DICOM headers) */
  serialNumberColumn?: boolean
}

@Injectable()
export class FeaturesService {
  constructor(private apollo: Apollo) {
    this.fetchFeatures()
  }

  features: FeatureList = {}

  fetchFeatures() {
    // `setting.key` is no longer the sole PK in multi-tenant — it's
    // composite with `clientId`. `setting_by_pk` would now require both
    // args. The clientId filter is applied by Hasura row-level permissions
    // from the JWT, so querying by `key` alone is correct.
    this.apollo
      .query<featuresSetting>({
        query: gql`
          query featuresSetting {
            setting(where: { key: { _eq: "features" } }, limit: 1) {
              json
            }
          }
        `,
      })
      .subscribe({
        next: (result) => {
          if (result.errors) {
            // every feature stays switched off below
            reportHandled(result.errors[0], 'load the feature settings')
          }
          const setting = result.data?.setting?.[0]
          if (setting) {
            this.features = setting.json
          }
        },
      })
  }
}
